/*
  Amaroso Delivery Engine
  Version 1.7
*/

(function () {
  'use strict';

  const AmarosoDelivery = {
    timeZone: 'Australia/Brisbane',
    cutoffHour: 15,
    announcementMarker:
      'same day dispatch on orders placed before 3pm aest',
    announcementSelector: '.announcement__carousel-item',
    updateIntervalMs: 30000,

    normaliseText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    },

    getBrisbaneTime() {
      const parts = new Intl.DateTimeFormat('en-AU', {
        timeZone: this.timeZone,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());

      const result = {};

      parts.forEach((part) => {
        if (part.type !== 'literal') {
          result[part.type] = part.value;
        }
      });

      return {
        weekday: result.weekday,
        hour: Number(result.hour),
        minute: Number(result.minute),
        second: Number(result.second)
      };
    },

    isWeekday(weekday) {
      return weekday !== 'Sat' && weekday !== 'Sun';
    },

    formatCountdown(secondsRemaining) {
      const safeSeconds = Math.max(0, secondsRemaining);
      const hours = Math.floor(safeSeconds / 3600);
      const minutes = Math.ceil((safeSeconds % 3600) / 60);

      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes} mins`;
      }

      if (hours > 0) {
        return `${hours}h`;
      }

      return `${Math.max(1, minutes)} mins`;
    },

    getDispatchMessage() {
      const now = this.getBrisbaneTime();

      if (!this.isWeekday(now.weekday)) {
        return '🚚 Order now for next business day dispatch';
      }

      const secondsNow =
        (now.hour * 3600) +
        (now.minute * 60) +
        now.second;

      const cutoffSeconds = this.cutoffHour * 3600;

      if (secondsNow >= cutoffSeconds) {
        return '🚚 Order now for next business day dispatch';
      }

      return (
        '🚚 Order within ' +
        this.formatCountdown(cutoffSeconds - secondsNow) +
        ' for same day dispatch'
      );
    },

    findDispatchSlide() {
      const slides = document.querySelectorAll(
        this.announcementSelector
      );

      for (const slide of slides) {
        if (
          slide.dataset.amarosoDispatch === 'true' ||
          this.normaliseText(slide.textContent) ===
            this.announcementMarker
        ) {
          slide.dataset.amarosoDispatch = 'true';
          return slide;
        }
      }

      return null;
    },

    getNativeTextElement(slide) {
      return (
        slide.querySelector('li') ||
        slide.querySelector('p') ||
        slide.querySelector('a') ||
        slide.firstElementChild ||
        slide
      );
    },

    refreshCarousel(slide) {
      const carousel = slide.closest('.js-announcement-carousel');

      if (
        carousel &&
        window.Flickity &&
        window.Flickity.data(carousel)
      ) {
        const flickity = window.Flickity.data(carousel);

        flickity.resize();
        flickity.reposition();
      }
    },

    updateAnnouncement() {
      const slide = this.findDispatchSlide();

      if (!slide) {
        return;
      }

      const textElement = this.getNativeTextElement(slide);
      const message = this.getDispatchMessage();

      if (textElement.textContent !== message) {
        textElement.textContent = message;
        this.refreshCarousel(slide);
      }
    },

    start() {
      this.updateAnnouncement();

      window.setInterval(
        () => this.updateAnnouncement(),
        this.updateIntervalMs
      );

      document.addEventListener(
        'shopify:section:load',
        () => this.updateAnnouncement()
      );

      document.addEventListener(
        'shopify:block:select',
        () => this.updateAnnouncement()
      );
    }
  };

  window.AmarosoDelivery = AmarosoDelivery;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => AmarosoDelivery.start(),
      { once: true }
    );
  } else {
    AmarosoDelivery.start();
  }
})();